import React from 'react'
import NotificationPreferences from '../components/NotificationPreferences'

const AccountPage = () => {
  return <NotificationPreferences />
}

export default AccountPage
